import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

import '../../assets/styles/App.css';
import "@fontsource/montserrat";


export default function CashFlowChart(props) {
  const canvas = useRef(null);

  const screenSize = (window.innerWidth >= 768);

  useEffect(() => {
      const config = {
        type: 'bar',
        data: {
          labels: props.labels,
          datasets: [{
              label: props.subtitle,
              backgroundColor: 'rgba(255, 230, 1, 1)',
              borderColor: 'rgba(255, 230, 1, 1)',
              data: props.dataset,
              fill: false,
              barThickness: 4,
            }
          ],
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          title: {
            display: false,
            text: "Orders Chart",
          },
          plugins: {
                    legend: {
                        display: false,
                        position: 'top',
                        labels: {
                            padding: 30,
                            color: 'white',
                            pointStyle: 'circle',
                            usePointStyle: true,
                        }
                    }
                },
          elements: {
            point:{
              radius: 0
            }
          },
          tooltips: {
            mode: "index",
            intersect: false,
          },
          hover: {
            mode: "nearest",
            intersect: true,
          },
          scales: {
            x: 
              {
                stacked: true,
                display: true,
                grid: {
                  display: false,
                  color: "rgba(238, 238, 238, 0.1)",
                  zeroLineColor: "rgba(0, 0, 0, 0)",
                },
                ticks: {
                  color: 'white',
                  autoSkip: true,
                  maxTicksLimit: 10,
                },
              },            
            y: {
                display: true,
                grid: {
                  display: true,
                  drawBorder: false,
                  color: "rgba(238, 238, 238, 0.1)",
                  zeroLineColor: "rgba(100, 100, 100, 0.1)",
                  zeroLineWidth: 1
                },
                ticks: {
                  color: 'white',
                  autoSkip: true,
                  maxTicksLimit: 6,
                  max: 30000000,
                  min: -20000000,
                },
              },
          },
        },
      };

      const chart = new Chart(canvas.current, config);
  
      return () => {
        // need cleanup because React runs useEffect callback twice in dev env
        chart.destroy();
      };
      
  }, [props.labels, props.dataset, props.title, props.subtitle]);
  return (
    <>
      <div className="w-full">
        <p className={`text-yellow text-16-19 mb-6 ${screenSize && 'px-8'}`}>{props.title}</p>
        <div className="relative h-400-px">
            <canvas ref={canvas}></canvas>
        </div>
      </div>
    </>
  );
}
